$(document).ready(function() {

    var sidebarVisivel = false;
    var sidebar = $('[data-sidebar]');
    var botaoFiltro = $('#botao-painel-filtros');
    var button = $('[data-sidebar-button]');
    var overlay = $('[data-sidebar-overlay]');
    var outSidebar = $('#paineis');

    function showSidebar() {
        sidebar.css('margin-left', '0');
        botaoFiltro.css('margin-left', (sidebar.width() - 5) + 'px');

        //deslocando o conteúdo, em caso de telas de medias a grandes
        outSidebar.removeClass('col-md-10 col-md-offset-1').addClass('col-md-9 col-md-offset-3');
        sidebarVisivel = true;
    }

    function hideSidebar() {
        sidebar.css('margin-left', sidebar.width() * -1 + 'px');
        botaoFiltro.css('margin-left', '0');

        outSidebar.removeClass('col-md-9 col-md-offset-3').addClass('col-md-10 col-md-offset-1');
        sidebarVisivel = false;
    }

    /* Mostra o filtro no carregamento inicial da página */
    showSidebar();

    sidebar.show(0, function() {
        sidebar.css('transition', 'all 0.5s ease');
    });

    if( $(window).width() >= 992 ){
        botaoFiltro.show(0, function() {
            botaoFiltro.css('transition', 'all 0.5s ease');
        });
    }

    function toggleSideBar() {
        if ( sidebarVisivel ) {
            hideSidebar();
        } else {
            showSidebar();
        }
    }

    // toggle sidebar on click
    button.click(function() {
        toggleSideBar();
        return false;
    });

    // hide sidebar on overlay click
    overlay.click(function() {
        hideSidebar();
    });

    outSidebar.on('click',function() {
        hideSidebar();
    });

});